import { useMediaQuery } from '@material-ui/core';
import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { storeViewMode } from '@/model/global/actions';
import { container } from '@/utils/ui';

const withMobileDetection = (Component: React.FunctionComponent) => (
  props: { [k in string]: unknown },
): JSX.Element => {
  const dispatch = useDispatch();
  const isMobileSaved = useRef<boolean | undefined>();
  const isMobile = useMediaQuery(
    `only screen and (max-width: ${container.mobileSwitchWidth}px),
     only screen and (max-height: ${container.mobileSwitchHeight}px)`,
  );
  if (isMobile !== isMobileSaved.current) {
    isMobileSaved.current = isMobile;
    storeViewMode({ isMobile })(dispatch);
  }

  const vhSaved = useRef<number | undefined>();
  const updateVHState = useCallback((): void => {
    // mobile address bar trick: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    const vh = window.innerHeight * 0.01;
    if (vh !== vhSaved.current) {
      vhSaved.current = vh;
      storeViewMode({ vh })(dispatch);
    }
  }, [dispatch]);
  useEffect(() => {
    if (vhSaved.current === undefined) {
      updateVHState();
    }
    window.addEventListener('resize', updateVHState);
    return (): void => window.removeEventListener('resize', updateVHState);
  });

  return <Component {...props} />;
};

export default withMobileDetection;
